import React from "react"

import { useField, useFormikContext } from "formik"

import ErrorMessage from "./ErrorMessage"

const CheckboxField = ({
  hideError = false,
  afterChange = undefined,
  isMulti = false,
  options = [],
  value = undefined,
  ...props
}) => {
  const [field, meta] = useField(props)
  const { setFieldValue } = useFormikContext()

  const computedOptions = [...options]
  if (!isMulti) computedOptions.push({ label: props.label, value: true })
  if (isMulti && value) computedOptions.push({ label: props.label, value })

  const fieldValue = field.value || (isMulti ? [] : false)

  return (
    <ul className="list-unstyled">
      {computedOptions.map(option => (
        <li key={option.value} className="form-group">
          <div className="form-check">
            <label
              className={`form-check-label ${props.disabled ? "disabled" : ""}`}
            >
              {option.label}
              <input
                {...field}
                onChange={e => {
                  if (isMulti) {
                    const newValues = [...fieldValue]
                    const index = fieldValue.indexOf(option.value)
                    const valueIsSelected = index >= 0
                    valueIsSelected
                      ? newValues.splice(index, 1)
                      : newValues.push(option.value)
                    setFieldValue(field.name, newValues)
                  } else {
                    setFieldValue(field.name, !fieldValue) // if isMulti is false, the field is a boolean
                  }
                  typeof afterChange === "function" && afterChange()
                }}
                className="form-check-input"
                type="checkbox"
                checked={
                  isMulti ? fieldValue.includes(option.value) : !!fieldValue
                }
                {...props}
              />
              <span className="form-check-sign" />
            </label>
          </div>
          {!hideError && <ErrorMessage {...meta} />}
        </li>
      ))}
    </ul>
  )
}

export default CheckboxField
